import $ from 'jquery';
import slick from 'slick-carousel';

export default {
	
	init() {

		var container = document.querySelectorAll('.carsCarusel');

		if( container.length != 0 ) {

			function carCarouselSlick( container ) {

				 $(container).on('breakpoint', function(event, slick, breakpoint) {

                    $(container).find(' .basic__title').removeClass('fit-content');
                    setTimeout(function(){ $(container).find('.basic__title').addClass('fit-content'); }, 500);

                });

                $(container).on('init', function(slick) {

                    $(container).find(' .basic__title').removeClass('fit-content');
                    setTimeout(function(){ $(container).find('.basic__title').addClass('fit-content'); }, 500);

                });

				$(container).slick({
					arrows: false,
					slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                    speed: 300,
                    autoplay: true,
                    autoplaySpeed: 1500,
                    rows: 0,
                    responsive : [
						{
							breakpoint : 1201,
							settings : {
								slidesToShow : 3,
							}
						},
						{
							breakpoint : 801,
							settings : {
								slidesToShow: 2,
							}
						},
						{
							breakpoint : 331,
							settings : {
								slidesToShow: 1,
							}
						}
					]
				});

			}

			container.forEach( function(box,index) {

				new carCarouselSlick(box);

			});

		}

	},
	finaliza() {

	}
};